import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddDepartment from "../Registration/Department/addDepartment";
import AltDepartment from "../Registration/Department/altDepartment";
import DelDepartment from "../Registration/Department/delDepartment";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Api from "../../services/api";
import Alert from "../../Components/alert/Alert";
import { handleColor } from "../../services/Functions";
import ReportDepartaments from "../Reports/reportDepartaments";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const prelude_department = () => {
  const [activeTab, setActiveTab] = React.useState("list");

  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentWillMount() {
    let array = [];
    await Api.get("/departments")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            Departamento: element.description,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    const items = [
      { id: "lg1", label: "Setores", eventKey: "list" },
      { id: "lg2", label: "Adicionar Setores", eventKey: "add" },
      { id: "lg3", label: "Alterar Setores", eventKey: "alt" },
      { id: "lg4", label: "Deletar Setores", eventKey: "del" },
    ];

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn">
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
               
                width: "100%",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="list">
                  {this.handleClick ? <ReportDepartaments /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddDepartment /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltDepartment /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelDepartment /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_department;
